<div class="wrapper">
  <div class="body">
    <div class="textarea">
      <textarea qmAutosize class="form-control" id="defTextarea"
                [(ngModel)]="notification.description"
                placeholder="{{'Description' | translate}}" rows="5" cols="100"></textarea>
    </div>
    <div class="buttons">
      <div class="save-button">
        <button type="button" class="btn btn-primary  save-button" (click)="save()"
                [disabled]="!notification.description">
          {{'Save' | translate}}
        </button>
      </div>
      <div class="cancel-button">
        <button type="button" class="btn btn-warning cancel-button" (click)="close()">
          {{'Cancel' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>

